import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./payroll-collapse-header.style";
import fileAccount from "@iconify/icons-mdi/file-account";
import { InlineIcon } from "@iconify/react";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyHrPayrollCollapseHeaderProps {
  label: string;
  ContractID: string | number;
  handleExpandClick: React.MouseEventHandler<HTMLButtonElement>;
  expanded: boolean;
}

export const MyHrPayrollCollapseHeader: React.FC<
  MyHrPayrollCollapseHeaderProps
> = ({ label, ContractID, handleExpandClick, expanded }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useOcIsMobile();

  return (
    <Box>
      <Box
        className={
          expanded === true
            ? classes.backgroundColorOnCollapse
            : classes.backgroundColorOffCollapse
        }
        padding="0px 16px"
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="contents" />
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems="center"
            marginLeft="16px"
          >
            <Typography
              variant="h6"
              style={{
                padding: "16px 0px",
                marginRight: "28px",
                color: `${theme.palette.gray80.main}`,
              }}
            >
              {label}
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              width={isMobile ? "100%" : "auto"}
            >
              <InlineIcon
                icon={fileAccount}
                width="24px"
                style={{ color: `${theme.palette.gray80.main}` }}
              />
              <Box
                style={{
                  marginLeft: "12px",
                  color: `${theme.palette.gray80.main}`,
                }}
              >
                {ContractID}
              </Box>
            </Box>
            {isMobile && <Box height="16px" />}
            <Box width="6px" />
            <Box paddingRight="28px" />
          </Box>
          <Box display="flex" alignItems="center" />
          <Box width="22px" />
          <IconButton
            id={String(ContractID)}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
            style={
              expanded
                ? {
                    padding: 0,
                    marginRight: "20px",
                    transform: "rotate(180deg)",
                  }
                : {
                    padding: 0,
                    marginRight: "20px",
                  }
            }
          >
            <ExpandMore />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default MyHrPayrollCollapseHeader;
